module.exports = __webpack_public_path__ + "img/6.37e813c0.png";